import type { User } from '@contexts/users/domain';
import { normalizeLanguage } from '@contexts/users/domain';

export function userMapper() {
	return {
		fromDTO: (dto: User): User => ({
			...dto,
			language: normalizeLanguage(dto.language) ?? dto.language
		})
	};
}
